"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformGaObject2Webview = void 0;
const transformGaObject2Webview = (gaObject) => {
    let res = {};
    const gaKeys = Object.keys(gaObject);
    // conversiones
    gaKeys.forEach((key) => {
        let changeApply = false;
        if (key === 'component_content') {
            res['component_copy'] = gaObject[key];
            changeApply = true;
        }
        if (key === 'component_name') {
            res['component_type'] = gaObject[key];
            changeApply = true;
        }
        if (key === 'event_type') {
            res['user_interaction'] = gaObject[key];
            changeApply = true;
        }
        if (key === 'component_product') {
            res['product'] = gaObject[key];
            changeApply = true;
        }
        if (!changeApply) {
            res[key] = gaObject[key];
        }
    });
    return res;
};
exports.transformGaObject2Webview = transformGaObject2Webview;
exports.default = exports.transformGaObject2Webview;
//# sourceMappingURL=index.js.map